import React, { useState, useEffect } from 'react';
import api from '../api';
import '../styles/loginForm.scss';
const loginImage = `${process.env.PUBLIC_URL}/assets/background_polos.png`;

const Register = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [masterKey, setMasterKey] = useState('');
  const [role, setRole] = useState(''); // Estado para Permissão
  const [polo, setPolo] = useState(''); // Estado para Polo
  const [error, setError] = useState(null);
  const [imageLoaded, setImageLoaded] = useState(false);

  // Função para pré-carregar a imagem
  const preloadImage = (src) => {
    return new Promise((resolve) => {
      const img = new Image();
      img.src = src;
      img.onload = () => resolve();
    });
  };

  useEffect(() => {
    // Pré-carregando a imagem
    preloadImage(loginImage).then(() => {
      setImageLoaded(true);
    });
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);

    try {
      // Fazendo a requisição para criar a conta
      const response = await api.post('/auth/register', {
        username,
        password,
        role,
        polo: role === 'Gerente' ? polo : undefined, // Incluindo o polo apenas se o role for Gerente
      }, {
        headers: {
          Authorization: `Bearer ${masterKey}`, // Usando a masterKey como Bearer Token
        },
      });

      alert('Cadastro bem-sucedido!');
      window.location.href = '/dashboard'; // Redireciona após o sucesso
    } catch (err) {
      setError(err.response ? err.response.data.message : 'Erro ao fazer cadastro');
    }
  };

  const handleLoginAccount = () => {
    window.location.href = '/';
  };

  return (
    <div className="login-container">
      {!imageLoaded && <div className="loading">Carregando...</div>}
      {imageLoaded && (
        <>
          <div className="login-form">
            <h2>Criar Conta</h2>
            <form onSubmit={handleSubmit}>
              <div>
                <label htmlFor="username">Usuário:</label>
                <input
                  type="text"
                  id="username"
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                  required
                />
              </div>
              <div>
                <label htmlFor="password">Senha:</label>
                <input
                  type="password"
                  id="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                />
              </div>
              <div>
                <label htmlFor="masterKey">Senha-Mestre:</label>
                <input
                  type="password"
                  id="masterKey"
                  value={masterKey}
                  onChange={(e) => setMasterKey(e.target.value)}
                  required
                />
              </div>
              <div>
                <label htmlFor="role">Permissão:</label>
                <select
                  id="role"
                  value={role}
                  onChange={(e) => {
                    setRole(e.target.value);
                    if (e.target.value !== 'Gerente') {
                      setPolo(''); // Limpa o polo se não for Gerente
                    }
                  }}
                  required
                >
                  <option value="">Selecione uma permissão</option>
                  <option value="Diretor">Diretor</option>
                  <option value="Gerente">Gerente</option>
                </select>
              </div>
              {role === 'Gerente' && (
                <div>
                  <label htmlFor="polo">Polo:</label>
                  <select
                    id="polo"
                    value={polo}
                    onChange={(e) => setPolo(e.target.value)}
                    required
                  >
                    <option value="">Selecione um polo</option>
                    <option value="polo. 0001">Polo 0001</option>
                    <option value="polo.0009">Polo 0009</option>
                    <option value="polo.0013">Polo 0013</option>
                    <option value="polo.0016">Polo 0016</option>
                    <option value="polo.0026">Polo 0026</option>
                    <option value="polo.0032">Polo 0032</option>
                    <option value="polo.0033">Polo 0033</option>
                    <option value="polo.0038">Polo 0038</option>
                    <option value="polo.0041">Polo 0041</option>
                    <option value="polo.0045">Polo 0045</option>
                    <option value="polo.0046">Polo 0046</option>
                    <option value="polo.0063">Polo 0063</option>
                    <option value="polo.0071">Polo 0071</option>
                    <option value="polo.0117">Polo 0117</option>
                    <option value="polo.0135">Polo 0135</option>
                    <option value="polo.0155">Polo 0155</option>
                    <option value="polo.0175">Polo 0175</option>
                    <option value="polo.0198">Polo 0198</option>
                    <option value="polo.0242">Polo 0242</option>
                    <option value="polo.0247">Polo 0247</option>
                    <option value="polo.0249">Polo 0249</option>
                    <option value="polo.0250">Polo 0250</option>
                  </select>
                </div>
              )}
              <button type="submit">Criar Conta</button>
              <button className='login-button' onClick={handleLoginAccount}>Entrar</button>
              {error && <p>{error}</p>}
            </form>
          </div>
          <div className="login-image">
            <img src={loginImage} alt="Imagem de Cadastro" />
          </div>
        </>
      )}
    </div>
  );
};

export default Register;
